import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {ref, computed, onMounted, useTemplateRef} from 'vue';

  
  import {intersectionService} from '@/bps/utilities/js/intersectionService/intersectionService';

  intersectionService.createObserver('lazyload', {rootMargin: '300px'});

  window.addEventListener('hashchange', () => {
    intersectionService.disable();

    setTimeout(() => {
      intersectionService.enable();
      intersectionService.activateAll('lazyload');
    }, 1000);

    // scroll to hash
    setTimeout(() => {
      const hash = window.location.hash;
      if (!hash) {
        return;
      }
      const targetElement = document.querySelector(hash);
      if (targetElement) {
        targetElement.scrollIntoView({behavior: 'smooth'});
      }
    }, 2000);
  });

export default /*@__PURE__*/_defineComponent({
  __name: 'lazyLoad',
  props: {
    tag: {},
    className: {}
  },
  emits: ["loaded"],
  setup(__props: any, { emit: __emit }) {

  const props = __props;
  const emit = __emit;

  const tag = props.tag ?? 'DIV';
  const className = props.className || null;
  const rootEl = useTemplateRef<HTMLElement>('rootEl');

  const isActive = ref(false);

  function onIntersection(element: Element) {
    isActive.value = true;
    emit('loaded', element);
    // info: this triggers mounted() on child components
  }

  const lazyClass = computed(() => (!isActive.value ? 'lazy-load' : className));

  onMounted(() => {
    intersectionService.observeElement('lazyload', rootEl.value, onIntersection);
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(tag)), {
    class: _normalizeClass(lazyClass.value),
    ref_key: "rootEl",
    ref: rootEl
  }, {
    default: _withCtx(() => [
      (isActive.value)
        ? _renderSlot(_ctx.$slots, "default", { key: 0 })
        : _createCommentVNode("v-if", true)
    ]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["class"]))
}
}

})